import {
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    styled,
    Typography,
} from "@mui/material";
import React from "react";

// Trigger
const DescGrid = styled(Grid)(({ theme }) => ({
    padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
    paddingLeft: "10%",
}));

type Props = {
    title: string;
    value: string; // "true" atau "false"
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function RadioButton({ title, value, onChange }: Props) {
    return (
        <Grid container justifyContent="center">
            <DescGrid container justifyContent="center">
                <TitleGrid item xs={12}>
                    <Typography variant="h6" color="black">
                        {title}
                    </Typography>
                </TitleGrid>
                <TitleGrid container justifyContent="flex-start" item xs={12}>
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={value}
                            onChange={onChange}
                            row
                        >
                            <FormControlLabel
                                value="true"
                                control={<Radio />}
                                label={<Typography color="black">Ya</Typography>}
                            />
                            <FormControlLabel
                                value="false"
                                control={<Radio />}
                                label={<Typography color="black">Tidak</Typography>}
                            />
                        </RadioGroup>
                    </FormControl>
                </TitleGrid>
            </DescGrid>
        </Grid>
    );
}
